import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { configShouldUseCustomBackgroundSelector } from 'embed/selectors/config'

import { LifeInsuranceOffer, LifeInsuranceProductSubType } from 'embed/constants/models'
import { formatCurrency, formatCurrencyWithDecimals, pluralize } from 'embed/utils'
import * as React from 'react'
import { connect } from 'react-redux'
import { MultiProductState } from 'ui/multi-product/reducers'
import { OfferFeatureBadges } from '../../common/OfferFeatureBadges'
import { Image } from '../../Results/ListItem'

const styles = require('./styles')

interface QuotePerMonthProps {
  offer: LifeInsuranceOffer
  status?: React.ReactElement
}

interface StoreProps {
  enableCustomBackground: boolean
}

interface SelectedOfferOwnProps {
  offer: LifeInsuranceOffer
  status?: React.ReactElement
}

type SelectedOfferProps = SelectedOfferOwnProps & StoreProps

const QuotePerMonth: React.FunctionComponent<QuotePerMonthProps> = ({ offer, status }) =>
  status !== undefined ? (
    status
  ) : (
    <>
      <span className={styles.value}>${formatCurrencyWithDecimals(offer.details.monthlyPremiumAmount)}</span>
      <p className={styles.label}>Per Month</p>
    </>
  )

export const SelectedOfferContainer: React.FunctionComponent<SelectedOfferProps> = ({
  enableCustomBackground,
  offer,
  status,
}) => {
  const onOfferClick = () => {}
  const isADB = offer.productSubType === LifeInsuranceProductSubType.AccidentalDeathBenefits
  const isWL = offer.productSubType === LifeInsuranceProductSubType.WholeLife
  const shouldShowBadges = offer.details.noMedicalTest || offer.details.onlineAppAvailable
  const containerStyle = enableCustomBackground ? { backgroundColor: 'white' } : {}

  return (
    <ThemeConsumer>
      {({ colorSecondary }) => (
        <div className={styles.container} style={containerStyle}>
          <div className={styles.header} style={{ backgroundColor: colorSecondary }}>
            <h2 className={styles.headerTextMd}>Your Selection</h2>
            <h2 className={styles.headerTextSm}>YOUR SELECTION: {offer.partner.name}</h2>
          </div>
          <div className={styles.premiumWrapper}>
            <div
              className={classnames(
                styles.imageContainer,
                styles.premiumItem,
                shouldShowBadges && styles.containerWithPadding,
              )}
            >
              <Image offer={offer} onOfferClick={onOfferClick} />
            </div>
            <OfferFeatureBadges offer={offer} columnView={true} />
          </div>
          <div className={styles.termsWrapper}>
            <div className={styles.termsItem}>
              <div className={classnames(styles.termsItem, styles.termsItemXs)}>
                <QuotePerMonth offer={offer} status={status} />
              </div>
            </div>
            <div className={styles.termsItem}>
              <span className={styles.value}>{`$${formatCurrency(offer.details.policyAmount)}`}</span>
              <p className={styles.label}>
                {isADB ? 'Accidental Coverage to Age 80' : isWL ? 'Lifetime Coverage' : 'Coverage'}
              </p>
            </div>
            {offer.details.termLength && offer.details.termUnit && (
              <div className={styles.termsItem}>
                <span className={styles.value}>
                  {offer.details.termLength} {pluralize(offer.details.termUnit, offer.details.termLength)}
                </span>
                <p className={styles.label}>Term</p>
              </div>
            )}
          </div>
        </div>
      )}
    </ThemeConsumer>
  )
}

const mapStateToProps = (state: MultiProductState) => ({
  enableCustomBackground: configShouldUseCustomBackgroundSelector(state),
})

export const SelectedOffer = connect(mapStateToProps)(SelectedOfferContainer)
